import { render } from "./CsrfInput.vue?vue&type=template&id=8b880910"
import script from "./CsrfInput.vue?vue&type=script&lang=js"
export * from "./CsrfInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__